import * as Yup from 'yup';
const phoneRegExp = /^([+])?[0-9]{0,14}$/;

function FooterFormValidation() {
  const validate = Yup.object({
    name: Yup.string().min(2).max(16).required('Type your name'),
    phone: Yup.string()
      .required('Phone is required')
      .matches(phoneRegExp, 'Phone number is not valid'),
    email: Yup.string()
      .email('Email is invalid')
      .min(8)
      .max(63)
      .required('Email is required')
      .test({
        message: 'Before @ at least 2 characters',
        test: value => value && value[0] && value[1] !== '@',
      })
      .test({
        message: 'Do not type dash at the start ',
        test: value => value && value[0] !== '-',
      })
      .matches(/[a-z0-9]+@[a-z0-9]+\.[a-z0-9]{2,3}/, 'Email is invalid'),
  });
  return validate;
}

export default FooterFormValidation;
